export default __webpack_public_path__ + "static/media/no_jobs_image.ad852b47.svg";